export default __webpack_public_path__ + "static/media/success-ball.50f46006.png";